import Link from 'next/link';

import type { ElementType } from 'react';

type ParseUrl = (href?: string) => {
  as: ElementType;
  isInternal?: boolean;
  tabIndex?: number;
  href: string;
  rel?: string;
  target?: string;
};

const parseUrl: ParseUrl = href => {
  if (!href) {
    return {
      as: 'div',
      tabIndex: -1,
      href: '',
    } as const;
  }

  if (href[0] === '/') {
    return {
      href,
      as: Link,
    };
  }

  const domain = ['www.magmutual.com', 'dev.magmutual.com', 'uat.magmutual.com'];

  let url: URL;
  try {
    url = new URL(href);
  } catch (error) {
    console.error(`Invalid URL encountered: ${href}`);

    return {
      as: 'div',
      tabIndex: -1,
      href: '',
    } as const;
  }

  const isInternal = domain.includes(url.hostname);

  return {
    as: isInternal ? Link : 'a',
    rel: isInternal ? '' : 'noreferrer noopener',
    target: isInternal ? '' : '_blank',
    href: isInternal ? url.href.split(url.host)[1] : href,
  } as const;
};

export default parseUrl;
